import 'linq-typed';

import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DefaultSettingsDialogComponent } from '@app/layout/default-settings-dialog/default-settings-dialog.component';
import { LanguageSwitchDialogComponent } from '@app/layout/language-switch-dialog/language-switch-dialog.component';
import { ChangePasswordDialogComponent } from '@app/users/change-password-dialog/change-password-dialog.component';
import { AppComponentBase } from '@shared/app-component-base';
import { AppNotificationType } from '@shared/AppEnums';
import { SignalRService } from '@shared/services/signalR.service';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AppAuthService } from '../../../../auth/app-auth.service';
import { DefaultSettingService } from '../../../../services/default-setting.service';
import { IMenuItem, NavigationService } from '../../../../services/navigation.service';
import { NotificationDetailDialogComponent } from '../notification-detail-dialog/notification-detail-dialog.component';
import {
  CommonServiceProxy,
  GetCurrentLoginInformationsOutput,
  NotificationServiceProxy,
  OrderServiceProxy,
  Parameter,
  PdaVersion,
  SessionServiceProxy,
  UserDto,
  UserNotificationState,
  UserServiceProxy,
} from './../../../../service-proxies/service-proxies';
import { TourService } from 'ngx-ui-tour-md-menu';
import { AppSessionService } from '@shared/session/app-session.service';
import { link } from 'fs';

'./../../../../../assets/sounds'
export interface INotification {
  message: string;
  notificationType: number;
  id: string;
  fresh: boolean;
  link: string;
  time: Date;
}
@Component({
  selector: 'app-header-sidebar-large',
  templateUrl: './header-sidebar-large.component.html',
  styleUrls: ['./header-sidebar-large.component.scss']
})

export class HeaderSidebarLargeComponent extends AppComponentBase implements OnInit {
  onlineUsers: UserDto[] = [];
  notifications: INotification[];
  currentUser: GetCurrentLoginInformationsOutput
  unreadNotificationCount: number = 0;
  nav: IMenuItem[];
  isShow=false;
  showMessage="";
  paymentUrl="";
  pageIndex = 1;
  itemsLength = 0;
  pageSize = 5;
  pdaVersion: PdaVersion;
  printUrl: Parameter;
  isDarkMode = localStorage.getItem('theme') === 'dark';

  constructor(
    private injector: Injector,
    public navService: NavigationService,
    private _authService: AppAuthService,
    private _defaultSettingService: DefaultSettingService,
    private _defaultSettingsService: DefaultSettingService,
    private _sessionService: SessionServiceProxy,
    private _dialog: MatDialog,
    private ref: ChangeDetectorRef,
    private _notificationService: NotificationServiceProxy,
    private _userService: UserServiceProxy,
    private _signalRService: SignalRService,
    private tourService:TourService,
    private _userServices: AppSessionService,
    private _commonService: CommonServiceProxy,
    private _orderService: OrderServiceProxy
  ) {
    super(injector);
    this.notifications = [];
  }

  toggleFilterTheme(event: MatSlideToggleChange) {
    this.isDarkMode = event.checked;
    if (this.isDarkMode) {
      document.body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.classList.remove('dark-mode');
      localStorage.setItem('theme', 'light');
    }
  }
  
  getOnlineUsers() {
    this._userService.getOnlineUsers().subscribe(res => {
      this.onlineUsers = res;
    })
  }
  pageChangeEvent(newPageIndex) {
    this.pageIndex = newPageIndex;
    this.getNotifications();
  }
  
  downloadFile(fileName: string) {
    this._orderService.getParameter2(0, 'ZeusPrint')
      .subscribe(result => {
        this.printUrl = result;
        this.startDownload(this.printUrl.value)
    });
  }

  downloadFile2(fileName: string) {
    this._commonService.getPdaVersion().subscribe((versionData: PdaVersion) => {
      this.pdaVersion = versionData;
      this.startDownload(this.pdaVersion.downloadLink)
    }); 
  }

  startDownload(url: string) {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', ''); 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  getDownloadUrl(fileName: string): string {
    const fileUrls = {
      'file1': 'path/to/file1.txt',  // url eklenecek
      'file2': 'path/to/file2.txt'
    };
    return fileUrls[fileName];
  }

  ngOnInit() {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    this.tourService.events$.subscribe(res=>{
      if(res.name =="end" && !this.tourService.hasNext(this.tourService.currentStep)){
           console.log("sidebar")
          this._defaultSettingsService.tourSendNext("header-sidebar");
          this.tourService.initialize([{
              anchorId: '7',
              content: this.l('InThisSectionYouCanViewNotifications'),
              title: this.l('Notificationss'),
              enableBackdrop: true,
              prevBtnTitle:this.l('Previous'),
              nextBtnTitle:this.l('Next'),
              closeOnOutsideClick: true,
              prevStep: '6'
            },{
              anchorId: '8',
              content: this.l('YouCanViewOnlineUsersInThisSection'),
              title: this.l('OnlineUserss'),
              enableBackdrop: true,
              prevBtnTitle:this.l('Previous'),
              nextBtnTitle:this.l('Next'),
              endBtnTitle:this.l('Done'),
              closeOnOutsideClick: true
            }
          ]);
          this.tourService.start();
          this.tourService.end();
          
      }
    })
    this._sessionService.getCurrentLoginInformations().subscribe(result => {
      this.currentUser = result
    })
    this.isShow=this._userServices._show;
    this.showMessage=this._userServices._message;
    this.paymentUrl=this._userServices._paymentUrl;
    this.navService.menuItems$.subscribe(res => {
      this.nav = res;
    });
    this.getNotifications();
    abp.event.on('abp.notifications.received', (userNotification) => {
      let notification: INotification = {
        id: userNotification.id,
        message: userNotification.notification.data.properties.Message,
        notificationType: userNotification.notification.data.properties.Type,
        fresh: true,
        link: "",
        time: userNotification.notification.creationTime
      }
      this.notifications.Add(notification);
      this.notifications = this.notifications.OrderByDescending(p => p.fresh).ToArray();
      this.unreadNotificationCount = this.notifications.Where(p => p.fresh).Count();
      this.ref.detectChanges();
      this.notificationSound();
    });
    abp.event.on('wms.onlineusers.received', (res) => {
      this.getOnlineUsers();
    })
    this.getOnlineUsers();
    this._signalRService.initOnlineUserHub();
    this._signalRService.onlineUsers();
  }
  getNotifications() {
    this.spinner.show();
    let res1 = this._notificationService.getAllNotificationsPaged(this.pageSize * (this.pageIndex - 1), this.pageSize)
    let res2 = this._notificationService.getUnreadNotificationCount();
    forkJoin([res1, res2])
      .pipe(
        finalize(() => this.spinner.hide())
      )
      .subscribe(result => {
        this.notifications = [];
        this.itemsLength = result[0].totalCount;
        result[0].items.forEach(element => {
          let notification: INotification = {
            id: element.id,
            message: element.notification.data.properties.Message,
            notificationType: element.notification.data.properties.Type,
            fresh: element.state == UserNotificationState._0 ? true : false,
            link: "",
            time: element.notification.creationTime
          }
          this.notifications.Add(notification);
        });
        this.unreadNotificationCount = result[1];

      });
  }
  makePayment() {
    // Ödeme yapma işlemleri burada gerçekleştirilir
    window.open(this.paymentUrl);
    console.log('Ödeme yapılıyor...');
  }
  notificationSound() {
    let audio = new Audio;
    audio.src = "../../../../../../assets/sounds/notification.wav";
    audio.load();
    audio.play();
  }
  toggelSidebar() {
    const state = this.navService.sidebarState;
    if (state.sidenavOpen) {
      this.nav.forEach(item => {
        item.active = false;
      })
      if (state.childnavOpen) {
        state.childnavOpen = false;
      }
      return state.sidenavOpen = false;
    }
    else {
      return state.sidenavOpen = true;
    }
    // if (state.childnavOpen && state.sidenavOpen) {
    //   return state.childnavOpen = false;
    // }
    // if (!state.childnavOpen && state.sidenavOpen) {
    //   return state.sidenavOpen = false;
    // }
    // if (!state.sidenavOpen && !state.childnavOpen) {
    //   state.sidenavOpen = true;
    //   setTimeout(() => {
    //     state.childnavOpen = true;
    //   }, 50);
    // }
  }

  onSetDefaults() {
    let d = this._dialog.open(DefaultSettingsDialogComponent);

    // d.afterClosed()
    //   .pipe(
    //     finalize(() => window.location.reload())
    //   )
  }

  onSetLanguage() {
    this._dialog.open(LanguageSwitchDialogComponent);
  }

  signout() {
    // this.auth.signout();
    this._defaultSettingService.clear();
    this._authService.logout();
  }
  changePassword() {
    this._dialog.open(ChangePasswordDialogComponent);
  }
  checkDropDown(open: boolean) {
    // if (!open) {
    //   this.notificationCount = 0;
    //   this.notifications.forEach(element => {
    //     element.fresh = false;
    //   });
    // }

  }
  markAsRead(item: INotification) {
    this._notificationService.markAsRead(item.id).subscribe();
    this._dialog.open(NotificationDetailDialogComponent, {
      data: item.id
    }).afterClosed()
      .subscribe(() => {
        item.fresh = false;
        this.notifications = this.notifications.OrderByDescending(p => p.fresh).ToArray();
        this.unreadNotificationCount = this.notifications.Where(p => p.fresh).Count();
        this.ref.detectChanges();
      })
  }
  getTitle(type) {
    if (type == AppNotificationType.General) {
      return this.l('GeneralNotification');
    }
    else if (type == AppNotificationType.Control) {
      return this.l('ControlNotification');
    }
    else if (type == AppNotificationType.Picking) {
      return this.l('PickingNotification');
    }
    else if (type == AppNotificationType.Placement) {
      return this.l('PlacementNotification');
    }
    else {
      return this.l('GeneralNotification');
    }
  }
  getTypedUserName(user: UserDto) {
    return user.name.toUpperCase() + " " + user.surname.toUpperCase();
  }
}
